import React from 'react';
import PropTypes from 'prop-types';

import { Flexer } from '@ontruck/orc';

import {
  VehicleType,
  VehiclePlateNumber,
  VehicleMaxPallets,
  VehicleMaxWeight,
  VehicleContainerHeight,
  VehicleContainerWidth,
  VehicleLifgateIcon,
  VehicleLateralLoadingIcon,
} from 'modules/journey/map/VehicleInfo';

const VehicleInfo = ({ country, vehicle, className }) => (
  <Flexer.Parent key={vehicle.id} alignItems="center" className={className}>
    <VehicleType
      width={35}
      small
      vehicle_type={vehicle.vehicle_type}
      container_length={vehicle.container_length}
    />
    <VehiclePlateNumber
      width={75}
      align="left"
      plate_number={vehicle.plate_number}
      className="monospace"
    />
    <VehicleMaxPallets
      align="right"
      width={40}
      country={country}
      max_pallets={vehicle.max_pallets}
    />
    <VehicleMaxWeight align="right" width={70} max_weight={vehicle.max_weight} />
    <VehicleContainerHeight align="right" width={60} container_height={vehicle.container_height} />
    <VehicleContainerWidth align="right" width={55} container_width={vehicle.container_width} />
    <VehicleLifgateIcon align="center" width={30} has_lifgate={vehicle.has_lifgate} />
    <VehicleLateralLoadingIcon
      align="center"
      width={30}
      has_lateral_loading={vehicle.has_lateral_loading}
    />
  </Flexer.Parent>
);

VehicleInfo.propTypes = {
  vehicle: PropTypes.object,
  country: PropTypes.string,
  className: PropTypes.string,
};

export default VehicleInfo;
